import React from 'react';
import { connect } from 'react-redux';

import MainContent from '../components/layout/MainContent';
import Title from '../components/typography/Title';
import LatestEventsContainer from '../containers/LatestEventsContainer';

import { createFetchingView } from '../helpers/views';

class EventsView extends React.PureComponent {
  renderContent() {
    return (
      <MainContent
        id="EventsView"
        className="sk-fade-in-quarter-second"
      >
        <Title align="center">Latest Events</Title>
        <LatestEventsContainer />
      </MainContent>
    );
  }

  render() {
    if (this.props.isReady) {
      return this.renderContent();
    }

    return null;
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: false,
  ...ownProps,
});

export default connect(mapStateToProps)(createFetchingView(EventsView));



// WEBPACK FOOTER //
// ./src/views/EventsView.js